import React, { useCallback } from 'react';

import { SUBCATEGORIES } from '../../common/categories';
import * as actions from '../../containers/General/generalActions';

import RadiusClient from './RadiusClient';
import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import Button from '../Controls/Button/Button';
import { SettingsFeatureLock } from '../LockedFeatures/SettingsFeatureLock';
import { useGetTabDisplay } from '../../hooks/lockedFeatures/useTabDisplay';

const { RADIUS_CLIENTS } = SUBCATEGORIES;

const RadiusClients = ({ fields, dispatch }) => {
    const radiusClients = fields[RADIUS_CLIENTS.ID];
    const { enabled } = useGetTabDisplay(RADIUS_CLIENTS.ID);

    const dispatchAdd = useCallback(() => {
        dispatch({ type: actions.ADD_RADIUS_CLIENT });
    }, [dispatch]);

    const dispatchUpdate = useCallback(
        (index, fieldId, value) => {
            dispatch({
                type: actions.UPDATE_RADIUS_CLIENT,
                payload: { fieldId: RADIUS_CLIENTS.ID, index, arrFieldId: fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchRemove = useCallback(
        (index) => {
            dispatch({ type: actions.REMOVE_RADIUS_CLIENT, payload: index });
        },
        [dispatch]
    );

    return (
        <>
            {radiusClients.value.map((radius, index) => {
                return (
                    <ArrayContainer
                        key={RADIUS_CLIENTS.ID + index}
                        header="RADIUS Client"
                        remove={() => enabled && dispatchRemove(index)}>
                        <RadiusClient radius={radius} changedFunc={(fId, v) => dispatchUpdate(index, fId, v)} />
                    </ArrayContainer>
                );
            })}
            <SettingsFeatureLock id={RADIUS_CLIENTS.ID} isTabId={true}>
                <Button
                    id="radius-client-add-radius-client"
                    style={{ marginTop: `${radiusClients.value.length === 0 ? '30px' : '0'}` }}
                    onClick={dispatchAdd}>
                    + Add RADIUS Client
                </Button>
            </SettingsFeatureLock>
        </>
    );
};

export default React.memo(RadiusClients);
